import { Editor, Range } from '@tiptap/react';

import { PromptChipAttrs, PromptChipInput } from './SlashExtension.types';

/** A template or today's string as chip attrs (a string is title and body). */
export function toPromptChipAttrs(input: PromptChipInput): PromptChipAttrs {
  if (typeof input === 'string') {
    return {
      templateId: null,
      version: null,
      title: input,
      body: input,
      templateBody: input,
      variables: [],
      values: {},
      edited: false,
    };
  }

  return {
    templateId: input.templateId ?? null,
    version: input.version ?? null,
    title: input.title,
    body: input.body,
    templateBody: input.templateBody || input.body,
    variables: input.variables ?? [],
    values: input.values ?? {},
    edited: input.edited ?? false,
  };
}

type InsertPromptChipArgs = {
  editor: Editor;
  chip: PromptChipInput;
  /** The `/` query to replace, when inserted from the slash menu. */
  range?: Range;
};

/** Inserts a chip and a space after it, at the caret or over `range`. */
export function insertPromptChip({
  editor,
  chip,
  range,
}: InsertPromptChipArgs) {
  const chain = editor.chain().focus();
  if (range) {
    chain.deleteRange(range);
  }

  chain
    .insertContent([
      { type: 'promptChip', attrs: toPromptChipAttrs(chip) },
      { type: 'text', text: ' ' },
    ])
    .run();
}
